var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewMoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8533 7.64591C10.9469 7.73966 10.9995 7.86675 10.9995 7.99925C10.9995 8.13175 10.9469 8.25883 10.8533 8.35258L5.85331 13.3526C5.75853 13.4409 5.63317 13.489 5.50363 13.4867C5.3741 13.4844 5.25051 13.4319 5.1589 13.3403C5.06729 13.2487 5.01481 13.1251 5.01253 12.9956C5.01024 12.8661 5.05833 12.7407 5.14665 12.6459L9.79331 7.99925L5.14665 3.35258C5.05833 3.2578 5.01024 3.13243 5.01253 3.0029C5.01481 2.87336 5.06729 2.74977 5.1589 2.65817C5.25051 2.56656 5.3741 2.51408 5.50363 2.5118C5.63317 2.50951 5.75853 2.55759 5.85331 2.64591L10.8533 7.64591Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMoreIcon);
export default __webpack_public_path__ + "static/media/ViewMoreIcon.8374c72a9943e0994cab3ddd861b9c08.svg";
export { ForwardRef as ReactComponent };